export const quickQuoteInterface = (state = {}, action) => {
  switch (action.type) {
    case 'LOAD_QUICK_QUOTE':
      return action.payload
    default:
      return state
  }
}
